import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { EventContentTab } from "@features/offer/shared/event";

export const PlayerStatisticsButton = observer(
	function PlayerStatisticsButton(props: {
		store: EventViewStore | AdditionalOfferViewStore;
	}) {
		const { t } = useTranslation();

		const { playerStatisticsStore } = props.store;

		return (
			<EventContentTab
				textContent={t("EVENT.HEADER.PLAYER_STATS")}
				isActive={
					props.store.displayStatisticsGroup ===
					StatisticsGroups.PlayerStats
				}
				disabled={playerStatisticsStore.isFetching}
				onClick={() => {
					props.store.setDisplayStatisticsGroup(
						StatisticsGroups.PlayerStats
					);
				}}
			/>
		);
	}
);
